<div class="modal-close" (click)="closeModal()">
  <fa-icon class="icon me-1" [icon]="faTimes"></fa-icon
  ><span>{{ "btn:close" | translate }}</span>
</div>
<div class="modal-header">
  <h5 class="modal-title">{{'invite:new:memeber:group' | translate}}</h5>
</div>
<div class="modal-body">
  <div class="container-fluid">
    <div class="row tabs-row">
      <div class="col text-center">
        <app-movie-tabs-wrapper [main]="true">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active py-3"
              id="activity-tab"
              (click)="getTab('inviteNewUser')"
              type="button"
              role="tab"
            >
              Invite New Users
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link py-3"
              id="conversation-tab"
              (click)="getTab('invited')"
              type="button"
              role="tab"
            >
              Invited
            </button>
          </li>
        </app-movie-tabs-wrapper>
      </div>
    </div>

    <div class="tab-content" id="myTabContent">
      <div
        class="tab-pane fade show active"
        id="all"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <div class="container py-4">
          <div *ngIf="loading" class="row max-heigth">
            <div class="row loadingCenter">
              <app-loading-icon></app-loading-icon>
            </div>
          </div>

          <div
            *ngIf="!loading"
            class="row justify-content-center max-heigth list-overflow"
          >
            <div *ngIf="actualTab == 'inviteNewUser'">
              <label class="form-label" for="search">{{
                "Enter the email to the users to be invited" | translate
              }}</label>
              <app-users-invited
                [usersSelected]="selectUsers"
              ></app-users-invited>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-6">
                  <div class="form-group">
                    <app-search-users
                      [internalUsers]="false"
                      id="search"
                      (searchEvent)="usersSelected($event)"
                      type="text"
                      placeholder="{{
                        'play_video:video_gift:enter_name' | translate
                      }}"
                    ></app-search-users>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6">
                  <div class="form-group">
                    <label class="form-label" for="name"> </label>
                    <input
                      id="name"
                      class="input-box w-100"
                      maxlength="80"
                      name="Name"
                      placeholder="{{ 'Name' | translate }}"
                      required=""
                      type="text"
                      [disabled]="true"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-5">
                <div class="form-group">
                  <label class="form-label" for="textarea">{{
                    "Write a message for the invitation" | translate
                  }}</label>
                  <textarea
                    [(ngModel)]="textMessage"
                    class="form-control"
                    id="textarea"
                    rows="3"
                  ></textarea>
                </div>
              </div>
            </div>

            <div *ngIf="actualTab == 'invited'">
              <app-empty-content
                *ngIf="!usersInvited?.length && !loading"
                [primaryText]="'collection:members:invited:empty' | translate"
              ></app-empty-content>
              <app-members-list
                *ngIf="usersInvited.length"
                [members]="usersInvited"
                [groupId]="group.id"
                [headers]="headers"
                [checkbox]="false"
                [actions]="true"
                [customBorder]="true"
              ></app-members-list>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group clearfix" *ngIf="actualTab == 'inviteNewUser'">
      <button
        (click)="sendInvitation()"
        [disabled]="!selectUsers.length"
        type="button"
        role="tab"
        class="btn btn-primary btn-create modal-btn-width float-right ms-2 fs-15 text-nowrap"
      >
        <fa-icon
          class="mr-2"
          [icon]="faCircleNorch"
          *ngIf="loadSpin"
          [spin]="true"
        ></fa-icon>
        {{ "Send Invitations" | translate }}
      </button>
    </div>
  </div>
</div>
